import React from 'react';
import PropTypes from 'prop-types';

// Components
import FlipMove from 'components/widgets/animation/flip-move';

// Component
export default function Timeline({ children }) {
  return (
    <FlipMove className="timeline">
      {children}
    </FlipMove>
  );
}

Timeline.propTypes = {
  children: PropTypes.node
};



// WEBPACK FOOTER //
// ./app/components/widgets/timeline/timeline.js